<div bsModal #addManagerModal="bs-modal" class="modal fade"
     tabindex="-1"
     role="dialog"
     aria-labelledby="addManagerModal"
     aria-hidden="true"
     [config]="{backdrop: 'static', keyboard: false}">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <form *ngIf="active" #addManagerForm="ngForm" novalidate (ngSubmit)="onSubmit()" autocomplete="off">
                <div class="modal-header">
                    <h4 class="modal-title">
                        <span *ngIf="!showAssignManagerToCompany || showCreateNewManager">{{"Axilla.Webshop.FieldAgent.Customer.AddManager" | localize}}</span>
                        <span *ngIf="showAssignManagerToCompany">{{"Axilla.Webshop.FieldAgent.Customer.ManagerAssign" | localize}}</span>
                    </h4>
                    <button type="button" class="close" (click)="close()" aria-label="Close" [disabled]="saving">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">

                    <ng-container *ngIf="!showAssignManagerToCompany && !showCreateNewManager">
                        <div class="p-field-radiobutton">
                            <p-radioButton
                                name="option"
                                value="personalEmail"
                                [(ngModel)]="emailType"></p-radioButton>
                            <label  class="ml-2">{{ "Axilla.Webshop.FieldAgent.Customer.Manager.PersonalEmail" | localize }}</label>
                        </div>

                        <div class="form-group">
                            <input id="EmailAddress"
                                   #managerEmailInput="ngModel"
                                   type="email"
                                   name="EmailAddress"
                                   class="form-control"
                                   [(ngModel)]="email"
                                   required
                                   maxlength="256"
                                   email />
                            <validation-messages [formCtrl]="managerEmailInput"></validation-messages>
                        </div>

                        <div class="p-field-radiobutton">
                            <p-radioButton name="option"
                                           value="companyEmail"
                                           inputId="companyEmail"
                                           [(ngModel)]="emailType"></p-radioButton>
                            <label class="ml-2">{{ "Axilla.Webshop.FieldAgent.Customer.Manager.UseCompanyEmail" | localize }}</label>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="!showAssignManagerToCompany && showCreateNewManager">
                        <div class="form-group">
                            <label for="Name">{{"Name" | localize}} *</label>
                            <input id="Name" #nameInput="ngModel" class="form-control" type="text" name="Name" [(ngModel)]="user.name" required maxlength="32">
                            <validation-messages [formCtrl]="nameInput"></validation-messages>
                        </div>

                        <div class="form-group">
                            <label for="Surname">{{"Surname" | localize}} *</label>
                            <input id="Surname" #surnameInput="ngModel" type="text" name="Surname" class="form-control" [(ngModel)]="user.surname" required maxlength="32">
                            <validation-messages [formCtrl]="surnameInput"></validation-messages>
                        </div>

                        <div class="form-group">
                            <label for="PhoneNumber">{{"PhoneNumber" | localize}} *</label>
                            <input id="PhoneNumber" type="text" name="PhoneNumber" class="form-control" [(ngModel)]="user.phoneNumber" maxlength="24">
                        </div>
                    </ng-container>

                    <ng-container *ngIf="!showCreateNewManager && showAssignManagerToCompany">
                        <p>
                            {{"Axilla.Webshop.FieldAgent.Customer.Manager.AreadyExist" | localize}}
                        </p>

                        <p><strong>{{manager.name}} {{manager.surname}}</strong></p>
                        <p><strong>{{manager.emailAddress}}</strong></p>

                        <p>
                            {{"Axilla.Webshop.FieldAgent.Customer.DoManagerAssign" | localize}}
                        </p>
                    </ng-container>

                </div>
                <div class="modal-footer">
                    <button [disabled]="saving" type="button" class="btn btn-default" (click)="close()">
                        {{"Cancel" | localize}}
                    </button>

                    <button *ngIf="isBackAvailable"
                        [disabled]="saving"
                        type="button"
                        class="btn btn-default"
                        (click)="back()">
                            {{"Back" | localize}}
                    </button>

                    <button *ngIf="isShowContinue"
                        type="button"
                        (click)="continue()"
                        class="btn btn-primary blue"
                        [disabled]="isContinueDisabled(addManagerForm.valid)">
                            {{"Continue" | localize}}
                    </button>

                    <button *ngIf="!isShowContinue && !isAssignAvailable"
                        type="submit"
                        class="btn btn-primary blue"
                        [disabled]="!isSaveAvailable"
                        [buttonBusy]="saving"
                        [busyText]="l('SavingWithThreeDot')">
                            <i class="fa fa-save"></i>
                            {{"Save" | localize}}
                    </button>

                    <button *ngIf="isAssignAvailable"
                            type="submit"
                            class="btn btn-primary blue"
                            [buttonBusy]="saving"
                            [busyText]="l('SavingWithThreeDot')">
                        <i class="fa fa-save"></i>
                        {{"Assign" | localize}}
                    </button>
                </div>
            </form>
        </div>
    </div>

</div>
